export enum RemoteEvalStatus {
    NotYet = -1,
    No = 0,
    YesWillDonate = 1,
    YesWillNotDonate = 2,
}